import { Mui, MuiStyles, MuiIcons } from '@osu/react-ui';
import { PROGRAM_COLOR_MAP,STATUSES } from '../../util/constants';
import { useGetNextApplicationForReviewerMutation } from "../../services/graphql/api";
import { addAlert } from "../../services/graphql/slices/global-alerts-slice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const createClasses = () => {
  return {
    chipLabel: {
      display: 'flex', justifyContent: 'left', width: '100%',
      '& .MuiChip-label': {
        width: '100%',
      },
    },
    chipLabelBox: {
        display: 'flex',
        justifyContent: 'space-between',
        textTransform: "uppercase",
        width: '100%',
    },
    cardChild: { display: 'flex', flexDirection: 'column', padding: '1rem', justifyContent: 'space-evenly', },
    cardText: { fontSize: "1rem" },
    pastDue: { fontSize: "1rem", color: "#BB0000", fontWeight: "bold" },
  };
};

export const PullCard = ({ card }) => {
  const { key, label, new_, inProgress, pastDue } = card;
  const programId = key;
  const theme = MuiStyles.useTheme()
  const classes = createClasses(theme);
  const pastDueClassName = pastDue > 0 ? classes.pastDue : classes.cardText;

  return (
    <Mui.Box aria-label={`committee card for ${label}`} style={{ display: 'flex', flexDirection: 'column' }}>
      <Mui.Paper style={{ padding: '1rem', width: '100%' }}>
        <Mui.Box style={{ display: 'flex', justifyContent: 'space-between' }} >
          <Mui.Chip
            sx={classes.chipLabel}
            variant="outlined"
            avatar={<MuiIcons.FiberManualRecord style={{ color: PROGRAM_COLOR_MAP[key] }} />}
            label={<Mui.Box sx={classes.chipLabelBox}><Mui.Typography>{label}</Mui.Typography></Mui.Box>}
            style={{ border: `1px solid ${PROGRAM_COLOR_MAP[key]}`, color: PROGRAM_COLOR_MAP[key] }}
            tabindex="0"
          />
        </Mui.Box>
        <Mui.Box className={'margin-top-2'}>
          <Mui.Typography sx={classes.cardText} color="textSecondary" tabindex="0">{new_} New</Mui.Typography>
          <Mui.Typography sx={classes.cardText} color="textSecondary" tabindex="0">{inProgress} In Progress</Mui.Typography>
          <Mui.Typography sx={pastDueClassName} color="textSecondary" tabindex="0">{pastDue} Past Due</Mui.Typography>
          <CardButton new_={new_} inProgress={inProgress} programId={programId} />
        </Mui.Box>
      </Mui.Paper>
    </Mui.Box>
  );
};

function CardButton({ new_, inProgress, programId }) {   
    if (new_ > 0) { return <ReadNextApplicationButton programId={programId} />; }
    
    if (inProgress > 0) { return <Mui.Button className="margin-top-1" variant="outlined" color="primary" disabled>IN PROGRESS</Mui.Button>; }
    
    return (
        <Mui.Button className="margin-top-1" variant="outlined" disabled color="primary" tabindex="0">
          ASSIGNMENT COMPLETE <MuiIcons.CheckCircle className='margin-left-1' style={{ color: '#1D5838', }} />
        </Mui.Button>
    );
}


function ReadNextApplicationButton({ programId }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [getNextApplication, result] = useGetNextApplicationForReviewerMutation();

    async function getNextApplicationAndRedirect() {
    const response = await getNextApplication({ programId });
    
    // Check if there's an error message from lambda
    if (response?.error) {
        return;
    }
    
    // If no lambda error, process the data
    const results = response?.data ?? {};
    
    // Check for status field (e.g., "No next application found")
    if (results?.status) { 
        return dispatch(addAlert({ message: results.message, severity: STATUSES.ERROR })); 
    }
    
    // Check for missing fields
    const missingField = !results?.applicantEmployeeId || !results?.programId || !results?.term;
    if (missingField) { 
        return dispatch(addAlert({ message: "Unable to pull next application.", severity: STATUSES.ERROR })); 
    }
    
    // Success - navigate to application
    navigate(`/applicant/${results.applicantEmployeeId}/${results.programId}/${results.term}`);
}
    
    const label = result?.isLoading ? "Loading Next Application..." : "Read Next Application";
    const spinner = result?.isLoading ? <Mui.CircularProgress size={20} style={{color: 'gray', marginRight: '1rem'}}/> : <></>;
    const announceChange = result?.isLoading ? "assertive" : "none";

    return (
        <Mui.Button aria-live={announceChange} className="margin-top-1" disabled={result?.isLoading} variant="outlined" color="primary" onClick={getNextApplicationAndRedirect}>{spinner} {label}</Mui.Button>
    );
}